import React from 'react'
import AnimateOnScroll from '../../ScrollAnimations/AnimateOnScroll'

const WebsiteDesignPhilosophy = () => {
    return (
        <div className="WebsiteDesignPhilosophy">
            <div className="InnerWebsiteDesignPhilosophy">
                <h2 className="base_heading_2">Rethinking Website Design</h2>
            </div>
            <div className="InnerWebsiteDesignPhilosophy">
                <AnimateOnScroll animationClass="slide-in-right" delay={0.5}>
                    <div className="PhilosophyCard">
                        <div className="head">Develop with Purpose</div>
                        <div>We don't design for the sake of looking good. Every layout, word, and pixel is placed with intent—to move users toward action and results.</div>
                    </div>
                </AnimateOnScroll>
                <AnimateOnScroll animationClass="slide-in-right" delay={0.5}>
                    <div className="PhilosophyCard">
                        <div className="head">Built for Conversion</div>
                        <div>With deep roots in performance marketing, our websites are optimized to convert using data-backed insights and proven CRO principles.</div>
                    </div>
                </AnimateOnScroll>
                <AnimateOnScroll animationClass="slide-in-right" delay={0.5}>
                    <div className="PhilosophyCard">
                        <div className="head">Brand-Aligned, User-Led</div>
                        <div>We blend brand storytelling with intuitive user journeys to create websites that reflect your identity and resonate with your audience.</div>
                    </div>
                </AnimateOnScroll>
                <AnimateOnScroll animationClass="slide-in-right" delay={0.5}>
                    <div className="PhilosophyCard">
                        <div className="head">Growth-Ready Frameworks</div>
                        <div>Our Development are scalable and structured to grow with your business without sacrificing performance or user experience.</div>
                    </div>
                </AnimateOnScroll>
                <AnimateOnScroll animationClass="slide-in-right" delay={0.5}>
                    <div className="PhilosophyCard">
                        <div className="head">Collaboration Over Handoffs</div>
                        <div>We work closely with your team through a transparent and iterative process that ensures every creative decision is aligned with your goals.</div>
                    </div>
                </AnimateOnScroll>
            </div>
        </div>
    )
}

export default WebsiteDesignPhilosophy